const LinkedIn = (props: SocialIconProps) => {
  const { className } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" className={className}>
      <rect
        width={62}
        height={62}
        x={1}
        y={1}
        strokeWidth={2}
        rx={31}
        className="fill-surface-secondary stroke-skin-stroke"
      />
      <path
        className="fill-skin-primary"
        fillRule="evenodd"
        d="M28.57 26.96h4.95v2.46c.72-1.41 2.55-2.69 5.3-2.69 5.26 0 6.51 2.83 6.51 8v9.6H40v-8.41c0-2.95-.71-4.62-2.53-4.62-2.52 0-3.56 1.8-3.56 4.62v8.41h-5.34V26.96zM19.43 44.1h5.33V26.73h-5.33v17.38zm6.1-23.04a3.37 3.37 0 0 1-1.01 2.4 3.45 3.45 0 0 1-4.85 0 3.4 3.4 0 0 1-1-2.4c0-.9.36-1.77 1-2.4a3.45 3.45 0 0 1 4.85 0 3.38 3.38 0 0 1 1 2.4z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default LinkedIn;
